export const defaultComponent = {
  id: '',
  server: {
    url: '',
    env: '',
  },
};
